import React from "react"
import "../../styles/aboutHistory.css";
import aboutImg from "../../img/about_history.jpg";

const AboutHistory: React.FC = () => {
    return (
        <>
            <div className="about_color">
                <div className="zoom_about_history">
                    <div className="about_text">
                        <h2 className="about_history_clinic">Sobre a Clínica</h2>
                    </div>
                    <div className="about_clinic">
                        <div className="about_history">
                            <p className="clinica_texto_about_history">
                                Nossa História
                                <br />
                                <br />
                                Somos referência em atendimento interdisciplinar a crianças, adolescentes, adultos e famílias, com foco em transtornos de desenvolvimento da aprendizagem. Fundada por Dra. Gilca Lucena Kortmann, profissional com sólida carreira.
                                <br />
                                <br />
                                Com mais de 10 mil atendimentos anuais é composta por profissionais multidisciplinares como Psicólogos, Fonoaudiólogos, Nutricionistas, Fisioterapêutas, Neurologistas e Psiquiatras. A clínica também se destaca por sua atuação na estimulação precoce e intervenção comportamental (ABA) no autismo. refletindo seu compromisso com a evolução contínua dos seus clientes e suporte às famílias.
                                <br />
                                <br />
                            </p>
                        </div>
                        <div className="image_about">
                            <div className="image_about_wrapper">
                                <img className="img_about_clinic" src={aboutImg} alt="Clinica Mediação" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AboutHistory;